import React from 'react'
import { Helmet } from 'react-helmet'

import '../../css/Blog.css'

import Tent from '../../assets/img/tent.jpg'

export default function PadDonation() {
  return (
    <div id="article">
      <Helmet>
        <title>EHDO Donated Sanitary Pads to Female Students - Enoho Fikir</title>
      </Helmet>

      <h1>EHDO Donated Feminine Sanitary Pads to Adwa Ber Female Students</h1>
      <img src={ Tent } />
      <p>One of the problems that girls with improverished parents face at schools is the lack of proper sanitary materials to take care of themselves during menstrual periods. Since their parents cannot afford to buy them sanitary pads, the girls face hygiene problems that affect their self-esteem and confidence. This often leads to absentness from class and in turn affects their academic performance. The gender club approached EHDO and explained the magnitude of the problem to EHDO asking for help. Taking this fact into consideration EHDO mobilized Ethiopian diaspora living abroad and managed to gather large amount of sanitary pads and donated to Adwa Ber administration on May 20, 2019.</p>
    </div>
  )
}